module.exports = __webpack_public_path__ + "static/media/JustFleckless–750OliveGrey.69662199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/JustFleckless–750OliveGrey.jpg
// module id = 24
// module chunks = 0